// @flow
import React from 'react';
import type { HttpError } from 'lib/errors';
import { EmptyCard } from 'components';

const SEARCH_ERROR_TITLE = "This search couldn't run.";

export function ClientErrorMessage(err: HttpError) {
  if (err.status === 400) {
    return (
      <EmptyCard
        title={SEARCH_ERROR_TITLE}
        message="You seem to have submitted an invalid request. If you think this is an error, contact PowerReviews Support."
      />
    );
  }

  if (err.status === 403) {
    return (
      <EmptyCard
        title={SEARCH_ERROR_TITLE}
        message="You don't seem to have permissions to run this search. If you think this is an error, contact PowerReviews Support."
      />
    );
  }

  return (
    <EmptyCard
      title={SEARCH_ERROR_TITLE}
      message="Could not run this search."
    />
  );
}

export function ServerErrorMessage() {
  return (
    <EmptyCard
      title={SEARCH_ERROR_TITLE}
      message="An Error occurred while running your search. If this error persists, contact PowerReviews Support."
    />
  );
}

export function NoItemsMessage() {
  return (
    <EmptyCard
      title="No Results"
      message="Sorry, your search did not return any results."
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/searchCollectionMessages.js